import * as React from "react";
import Utils from "../../helper/utils";
import ParceiroListagem from "./listagem";
import { useTranslation } from "react-i18next";

const ParceiroPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.partners.titlePage"));

  return (
    <React.Fragment>
      <ParceiroListagem />
    </React.Fragment>
  );
};

export default ParceiroPage;
